var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerFloatTitle"},[_c('div',{staticClass:"head"},[_c('font',[_vm._v(_vm._s(_vm.title))])],1),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }